(function ($) {

	/* Navigation Toggle
		 ========================================================================== */

	$(document).on('click', '.navigation-toggle', function (e) {
		e.preventDefault();
		$(this).toggleClass('navigation-toggle-active');
		$('.navigation-collapse').toggleClass('navigation-open');
	});

	/* Sub Menu Toggle
		 ========================================================================== */

	$(document).on("click", ".sub-menu-toggle", function (e) {
		e.preventDefault();
		$(this).toggleClass("active");
		$(this).parent().parent().children(".sub-menu").toggleClass("active");
	});

	$(document).ready(function ($) {

		/* Search Toggle
			 ========================================================================== */

		$(document).on("click", "#masthead .search-toggle", function (e) {
			e.preventDefault();
			$("#masthead .search-toggle").toggleClass("active");
			$("#masthead .search-form").toggleClass("active");
			$("#masthead .search-field").focus();
		});

		/* HTML5 Placeholder
			 ========================================================================== */

		$('input, textarea').placeholder();

		/* Cycle 2
			 ========================================================================== */

		$('[data-cycle-slideshow]').cycle();

		/**
		 * Cycle 2 Responsive
		 */

		$(window).on("load resize", function () {
			$('[data-cycle-responsive="true"]').each(function () {

				var slider = $(this),
					innerWrapper = slider.find('.cycle-slide'),
					largest;

				// Reset min-height
				innerWrapper.css('min-height', 0 + 'px');

				largest = Math.max.apply(null, innerWrapper.filter(':not(.cycle-sentinel)').map(function () {
					return $(this).innerHeight();
				}).get());

				// Set min-height	
				innerWrapper.css('min-height', largest + 'px');
			});

		}).resize();

		/* Tabset
			 ========================================================================== */

		var allTabLinks = $('[data-tab]'),
			allTabContents = $('[data-content]');

		$('[data-tabset]').each(function () {
			var wrapper = $(this),
				group = wrapper.data('tab-group'),
				scope = '[data-tab-group=' + group + ']',
				tabs = allTabLinks.filter(scope),
				content = allTabContents.filter(scope);

			tabs.on('click', function (event) {
				var tab = $(this),
					activeTab = tab.data('tab');

				tabs
					.removeClass('tab-link-active')
					.filter("[data-tab=" + activeTab + "]").addClass('tab-link-active');

				content
					.hide()
					.filter('[data-content=' + activeTab + ']').show();

				// Anchor the window to the active tab on extra small and small screens.
				if (window.innerWidth < 768) {
					$('html, body').animate({ scrollTop: tab.offset().top }, 200);
				}

				event.preventDefault();
			});

			/**
			 * Warning: if you have duplicate tabs for both horizontal and vertical tabs
			 * simultaneously, this will wrap navigation around from start to finish because:
			 *
			 *   - Tab 1
			 *   - Tab 2
			 *   - Tab 3
			 *   - Tab 1
			 *
			 * Click next, and Tab 3 will wrap to Tab 1 because the second set of tabs'
			 * Tab 1 is next.
			 */

			wrapper.on('click', '[data-tab-prev]' + scope, function (event) {
				for (var i = tabs.length - 1; i >= 0; i--) {
					var tab = tabs.eq(i);

					if (tab.is('.tab-link-active')) {
						if (i > 0) {
							// Only go to the previous tab so long as we aren't on the first tab
							tabs.eq(i - 1).trigger('click');
						}

						break;
					}
				}

				event.preventDefault();
			});

			wrapper.on('click', '[data-tab-next]' + scope, function (event) {
				for (var i = 0, last = tabs.length - 1; i < last; i++) {
					var tab = tabs.eq(i);

					if (tab.is('.tab-link-active')) {
						if (i < last) {
							// Only go to the next tab so long as we aren't on the last tab
							tabs.eq(i + 1).trigger('click');
						}

						break;
					}
				}

				event.preventDefault();
			});
		});

		/* Accordion
			 ========================================================================== */

		var accordion = '[data-accordion]',
			accordionHeader = '[data-accordion-header]',
			accordionContent = '[data-accordion-content]',
			accordionActiveClass = 'accordion-active';

		$(accordion)
			.find(accordionContent).hide().end()
			.find(accordionHeader + ':first').addClass(accordionActiveClass).end()
			.find(accordionContent + ':first').show().end()
			.on('click', accordionHeader, function (event) {
				var self = $(this),
					accordionBody = self.closest(accordion);

				if (!self.hasClass(accordionActiveClass)) {
					accordionBody
						.find(accordionHeader).removeClass(accordionActiveClass).end()
						.find(accordionContent).slideUp().end();

					self.addClass(accordionActiveClass)
						.next(accordionContent).slideDown().end();
				}

				event.preventDefault();
			});

	}); // end.ready

}(jQuery));